/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} The_InterviewInputs */

const en_the_interview = /** @type {(inputs: The_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Interview`)
};

const es_the_interview = /** @type {(inputs: The_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La Entrevista`)
};

const fr_the_interview = /** @type {(inputs: The_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'Entrevue`)
};

const de_the_interview = /** @type {(inputs: The_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Interview`)
};

const ja_the_interview = /** @type {(inputs: The_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インタビュー`)
};

const zh_the_interview = /** @type {(inputs: The_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`访谈录`)
};

const ar_the_interview = /** @type {(inputs: The_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المقابلة`)
};

const id_the_interview = /** @type {(inputs: The_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wawancara`)
};

const it_the_interview = /** @type {(inputs: The_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'Intervista`)
};

const ru_the_interview = /** @type {(inputs: The_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Интервью`)
};

const pt_the_interview = /** @type {(inputs: The_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Entrevista`)
};

const ko_the_interview = /** @type {(inputs: The_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인터뷰`)
};

/**
* | output |
* | --- |
* | "The Interview" |
*
* @param {The_InterviewInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const the_interview = /** @type {((inputs?: The_InterviewInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<The_InterviewInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_the_interview(inputs)
	if (locale === "es") return es_the_interview(inputs)
	if (locale === "fr") return fr_the_interview(inputs)
	if (locale === "de") return de_the_interview(inputs)
	if (locale === "ja") return ja_the_interview(inputs)
	if (locale === "zh") return zh_the_interview(inputs)
	if (locale === "ar") return ar_the_interview(inputs)
	if (locale === "id") return id_the_interview(inputs)
	if (locale === "it") return it_the_interview(inputs)
	if (locale === "ru") return ru_the_interview(inputs)
	if (locale === "pt") return pt_the_interview(inputs)
	return ko_the_interview(inputs)
});